import React from 'react';
import styles from './OrderDetailPanel.module.css';
import { Tag, BtnSecondary } from './Styled';
import { formatCurrency, formatNegative, formatDateTime } from '../utils';

const TYPE_ICON = { Delivery: '🚴', Pickup: '🥡', Dinein: '🍽' };

const OrderDetailPanel = ({ order, onClose }) => {
  const infoRows = [
    ['Menu Order ID', order.menuOrderId],
    ['Order Ref', order.orderReference],
    ['Date & Time', formatDateTime(order.orderDate)],
    [
      'Type',
      <Tag variant="bl">
        {TYPE_ICON[order.serviceType] || '🍽'} {order.serviceType}
      </Tag>,
    ],
    ['Place', order.placeName],
  ];

  return (
    <div className={styles.panel}>
      <div className={styles.panelHeader}>
        <div>
          <div className={styles.panelTitle}>Order Detail</div>
          <div className={styles.orderId}>{order.menuOrderId}</div>
        </div>
        <BtnSecondary onClick={onClose}>✕ Close</BtnSecondary>
      </div>

      <div className={styles.body}>
        <div className={styles.section}>
          <div className={styles.sectionTitle}>Order Info</div>
          {infoRows.map(([key, val]) => (
            <div key={key} className={styles.infoRow}>
              <span className={styles.infoKey}>{key}</span>
              <span className={styles.infoVal}>{val}</span>
            </div>
          ))}
        </div>

        <div className={styles.section}>
          <div className={styles.sectionTitle}>Sale Value Breakdown</div>
          <div className={styles.finBlock}>
            <div className={styles.finRow}>
              <span className={styles.finLabel}>Food Sales (incl. GST)</span>
              <span className={styles.finVal}>{formatCurrency(order.saleValue)}</span>
            </div>
            {order.subTotalGst > 0 && (
              <div className={styles.finRow}>
                <span className={styles.finLabel}>Sub Total GST</span>
                <span className={styles.finVal}>{formatCurrency(order.subTotalGst)}</span>
              </div>
            )}
            {order.promo < 0 && (
              <div className={styles.finRow}>
                <span className={styles.finLabel}>Promo</span>
                <span className={styles.finVal}>{formatNegative(Math.abs(order.promo))}</span>
              </div>
            )}
            {order.venueCharges > 0 && (
              <div className={styles.finRow}>
                <span className={styles.finLabel}>Venue Charges</span>
                <span className={styles.finVal}>{formatCurrency(order.venueCharges)}</span>
              </div>
            )}
            {order.deliveryFee > 0 && (
              <div className={styles.finRow}>
                <span className={styles.finLabel}>Delivery Fee</span>
                <span className={styles.finVal}>{formatCurrency(order.deliveryFee)}</span>
              </div>
            )}
            {order.deliveryFeeDiscount !== 0 && (
              <div className={styles.finRow}>
                <span className={styles.finLabel}>Delivery Discount</span>
                <span className={styles.finVal}>{formatNegative(Math.abs(order.deliveryFeeDiscount))}</span>
              </div>
            )}
            {order.deliveryFeeNet > 0 && (
              <div className={styles.finRow}>
                <span className={styles.finLabel}>Net Delivery Fee</span>
                <span className={styles.finVal}>{formatCurrency(order.deliveryFeeNet)}</span>
              </div>
            )}
            {order.adjustmentAmount !== 0 && (
              <div className={styles.finRow}>
                <span className={styles.finLabel}>Adjustment</span>
                <span className={styles.finVal}>
                  {order.adjustmentAmount < 0
                    ? formatNegative(Math.abs(order.adjustmentAmount))
                    : formatCurrency(order.adjustmentAmount)}
                </span>
              </div>
            )}
            {order.applicationFee > 0 && (
              <div className={styles.finRow}>
                <span className={styles.finLabel}>Application Fee</span>
                <span className={styles.finVal}>{formatNegative(order.applicationFee)}</span>
              </div>
            )}
            {order.creditCardFees > 0 && (
              <div className={styles.finRow}>
                <span className={styles.finLabel}>Credit Card Fees</span>
                <span className={styles.finVal}>{formatNegative(order.creditCardFees)}</span>
              </div>
            )}
            {order.kraveinCharges > 0 && (
              <div className={styles.finRow}>
                <span className={styles.finLabel}>KRAVEiN Charges</span>
                <span className={styles.finVal}>{formatNegative(order.kraveinCharges)}</span>
              </div>
            )}
            {order.kraveinFeeGst > 0 && (
              <div className={styles.finRow}>
                <span className={styles.finLabel}>KRAVEiN Fee GST</span>
                <span className={styles.finVal}>{formatNegative(order.kraveinFeeGst)}</span>
              </div>
            )}
            <div className={styles.finRow}>
              <span className={styles.finLabel}>KRAVEiN Fee (incl. GST)</span>
              <span className={styles.finVal}>{formatNegative(order.krvFee)}</span>
            </div>
            <div className={`${styles.finRow} ${styles.netRow}`}>
              <span className={styles.finLabel}>Net Payout</span>
              <span className={styles.finVal}>{formatCurrency(order.netPayout)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetailPanel;
